import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from 'redux';
import ActionTypes from '../../../../../constants/ActionTypes';
import UrlService from '../../../../../services/UrlService';
import { createSearchParamsManhattanAction } from '../../../searchParams/actions';
import * as queryString from "query-string";
import history from '../../../../../utilites/history';
import { setBundleSelectedDataAction } from '../../bundleData/actions';
import { BundleProductPricesTypes } from '../../../../../constants/BundleProductPricesTypes';
import { Purchases } from '../../../../../constants/Purchases';
import { BundleProductLines } from '../../../../../constants/BundleProductLines';


export const singleProductMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);
  const bundleData = store.getState().manhattan.bundleData;

  switch (action.type) {
  case ActionTypes.MANHATTAN.FTTH.SINGLE_PRODUCT.CHANGE_PURCHASE_MANHATTAN:
    // quantity is one according to business logic
    next(createSearchParamsManhattanAction({ singleProductType: action.payload.purchase.type }));
    setPropertyForSelectedProducts(bundleData.selectedProducts[0], "fix", 1, getPurchaseType(action.payload.purchase.type));
    next(setBundleSelectedDataAction(bundleData.selectedProducts));
    break;
  case ActionTypes.MANHATTAN.POST_OTT.SINGLE_PRODUCT.CHANGE_PURCHASE_MANHATTAN:
    next(createSearchParamsManhattanAction({ singleProductType: action.payload.purchase.type }));
    setPropertyForSelectedProducts(bundleData.selectedProducts[0], "stb", 1, getPurchaseType(action.payload.purchase.type));
    next(setBundleSelectedDataAction(bundleData.selectedProducts));
    break;
  case ActionTypes.MANHATTAN.FTTH.SINGLE_PRODUCT.SET_PURCHASE_MANHATTAN:
    setPropertyForSelectedProducts(bundleData.selectedProducts[0], "fix", 1, getPurchaseType(action.payload.purchase.type));
    next(setBundleSelectedDataAction(bundleData.selectedProducts));
    break;
  case ActionTypes.MANHATTAN.POST_OTT.SINGLE_PRODUCT.SET_PURCHASE_MANHATTAN:
    setPropertyForSelectedProducts(bundleData.selectedProducts[0], "stb", 1, getPurchaseType(action.payload.purchase.type));
    next(setBundleSelectedDataAction(bundleData.selectedProducts));
    break;
  case ActionTypes.MANHATTAN.FTTH.SINGLE_PRODUCT.REMOVE_PURCHASE_FROM_SINGLE_PRODUCT:
  case ActionTypes.MANHATTAN.POST_OTT.SINGLE_PRODUCT.REMOVE_PURCHASE_FROM_SINGLE_PRODUCT:
    const params = UrlService.getParamsFromUrlOnLoadPage();
    delete params['singleProductType'];
    history.push({
      search: queryString.stringify({ ...params }),
    });
    if (bundleData.selectedProducts[0].productLine === BundleProductLines.POSTPAID_OTT) {
      setPropertyForSelectedProducts(bundleData.selectedProducts[0], "stb", 0, "");
    } else {
      setPropertyForSelectedProducts(bundleData.selectedProducts[0], "fix", 0, "");
    }
    next(setBundleSelectedDataAction(bundleData.selectedProducts));
    break;
  }
};

const setPropertyForSelectedProducts = (selectedProducts: any, propertyName:string, quantity: number, purchaseType: string) => {
  selectedProducts[propertyName].quantity = quantity;
  selectedProducts[propertyName].purchaseType = purchaseType;
};

const getPurchaseType = (type: string) => {
  return type === Purchases.COSMOS ? BundleProductPricesTypes.CREDIT_PRICE24 : BundleProductPricesTypes.FIRST_BILL;
};
